/** No query strings, referral codes, user IDs or personal information enter analytics. */
export function beatportClickDetails(href: string, sourcePath: string, catalogue?: { kind?: string; id?: string }) {
  try {
    const target = new URL(href);
    if (target.protocol !== "https:" || !/(^|\.)beatport\.com$/i.test(target.hostname)) return null;
    const source = sourcePath.split(/[?#]/)[0].slice(0, 500);
    const match = source.match(/^\/(track|release)\/[^/]+\/([a-zA-Z0-9_-]+)\/?$/);
    return {
      affiliate_partner: "beatport",
      source_path: source,
      destination_path: target.pathname.slice(0, 500),
      catalogue_kind: catalogue?.kind === "track" || catalogue?.kind === "release" ? catalogue.kind : match?.[1] || "other",
      catalogue_id: catalogue?.id && /^[a-zA-Z0-9_-]{1,64}$/.test(catalogue.id) ? catalogue.id : match?.[2] || "",
    };
  } catch { return null; }
}
